<template>
	<div class="ht-profile-user-orders">
		<Loading :active.sync="loading"></Loading>
		<b-table
			:data="orders"
			hoverable
			:paginated="false"
			per-page="-1"
			detailed
			detail-key="id"
			:opened-detailed="defaultOpenedDetails"
			@details-open="(row, index) => closeAllOtherDetails(row, index)"
			@click="(row, index) => closeAllOtherDetails(row, index)"
			focusable
			:row-class="(row, index) => row.id == defaultOpenedDetails && 'is-selected'"
			>
			<template slot-scope="props">
				<b-table-column field="id" :label="$t('Transaction id')">{{ props.row.order_id }}</b-table-column>
				<b-table-column field="type" :label="$t('Type')">{{ $t(props.row.type) }}</b-table-column>
				<b-table-column field="type" :label="$t('Post method')">
					<span v-if="props.row.payload">{{ $t(props.row.payload.post_method.name) }}</span>
				</b-table-column>
				<b-table-column field="type" :label="$t('Date')">{{ props.row.created | moment }}</b-table-column>				
				<b-table-column field="type" :numeric="true" :label="$t('Shipping cost')">
					<span v-if="props.row.payload">{{
						props.row.payload.post_method.price[
							props.row.payload.user_data.country_code
								? props.row.payload.user_data.country_code.toLowerCase() == 'hu'
									? 'hu'
									: 'other'
								: 'hu'
						] | toUserCurrency($data._this)
					}}</span>
				</b-table-column>
				<b-table-column field="price" :numeric="true" :label="$t('Price')">{{
					props.row.price | toUserCurrency($data._this)
				}}</b-table-column>
				<b-table-column field="status" :label="$t('Status')">{{ $t(props.row.status_text) }}</b-table-column>
				<b-table-column>
					<b-button
						v-if="props.row.status_text == 'failed' && cart == true && props.index == 0"
						@click="$root.$emit('changeTab', 0)"
						>{{ $t('Cart') }}</b-button
					>
				</b-table-column>
			</template>
			<template slot="detail" slot-scope="props">
				<UserPaysItems :order_id="props.row.id" :status="props.row.status"></UserPaysItems>
			</template>
		</b-table>
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import UserPaysItems from '@/components/frontend/profiles/UserPaysItems.vue'

export default {
	components: {
		Loading,
		UserPaysItems,
	},
	data() {
		return {
			loading: true,
			orders: [],
			showDetailsIcon: null,
			total: 0,
			checkOutTotal: 0,
			cart: false,
			selected: null,
			defaultOpenedDetails: [],
			// eslint-disable-next-line vue/no-reserved-keys
			_this: this,
		}
	},
	props: {
		selectAuction: null,
		selectedTab: null,
		seller: {
			type: Boolean,
			default: false
		},
		winner: {
			type: Boolean,
			default: false
		},
		refresh: null,
	},
	mounted() {
		this.fetchList(() => {
			this.getCart()
		})
		console.log('USER', this.$store.getters.userpref)
	},
	methods: {
		goToFirstab(){
			this.$root.$emit('changeTab', 0)
			this.$root.$emit('updateCart')
		},
		closeAllOtherDetails(row) {
			this.defaultOpenedDetails = [row.id]
		},
		total_price: function (rows) {
			const total = []
			Object.entries(rows).forEach(([value, index]) => {
				total.push(index.price)
			})
			return total.reduce(function (total, num) {
				return total + num
			}, 0)
		},
		fetchList: function (cb) {
			var _this = this
			_this.loading = true
			var path = '/order/' + this.selectAuction
			_this.$http.post(path).then((response) => {
				console.log(response)
				_this.orders = response.data.orders
				if (typeof cb == 'function') {
					cb()
				} else {
					_this.loading = false
				}
				//_this.total = _this.price_total + ' HUF';
			})
		},
		getCart: function () {
			var _this = this
			var path = '/won-bids/' + this.selectAuction
			_this.$http.get(path).then((response) => {
				console.log(response)
				_this.cart = response.data.wonbids.length > 0
				_this.loading = false
				//_this.total = _this.price_total + ' HUF';
			})
		},
		startPay() {
			alert('XXX')
		},
	},
	watch: {
		selectedTab: function (newVal) {
			if (newVal == 3) {
				this.fetchList(() => {
					this.getCart()
				})
			}
		},
		selectAuction: function () {
			this.fetchList()
		},
		bids: function (newVal) {
			this.total = this.total_price(newVal)
		},
		refresh: function () {
			if (this.selectedTab == 3) {
				this.fetchList(() => {
					this.getCart()
				})
			}
		},
	},
}
</script>
